export const DOCUMENTATION_BROWSER_LIST_HEIGHT = 240;
export const DOCUMENTATION_BROWSER_MAX_WIDTH = 680;
